import {get} from '../../common/utils/FetchUtils';


export async function getWaiver(language) {
  return (await get(`/api/waivers/current/${language}`)).json();
}

